import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const kikReachLoginResponseSchema = z.object({
  redirect_url: z.string(),
});

const kikReachErrorResponseSchema = z.object({
  error: z.string(),
});

export const kikReachApiDefinitions = prefixApi(
  "/kikreach",
  apiBuilder({
    alias: "kikReachLogin",
    method: "post",
    path: "/login/",
    response: kikReachLoginResponseSchema,
    errors: [
      {
        status: 400,
        schema: kikReachErrorResponseSchema,
      },
      {
        status: 502,
        schema: kikReachErrorResponseSchema,
      },
    ],
  }).build(),
);
